$(document).ready(function() {
	$('body').on('click', 'header .main-navbar-toggler', function () {
		$('html, body').toggleClass('modal-open');
	});

	$('.main-navbar-toggler').click(function(){
		$('#main-menu-toggler').toggleClass('open');
	});

    $("#navbar").on("click", "button", function(){
		$(this).blur();
	});

	// Hide a collapsed sub navbar if triggering mega menu.
	$('.dropdown-toggler').on('click', function() {
		if($('.sub-nav-content').hasClass('show')) {
			$('.navbar-collapse').collapse('hide');
		}
	});
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/layout/header.js
// module id = 12
// module chunks = 0